require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-redux-get-state-from-the-redux-store.json") })
        }
      }, "path---front-end-libraries-redux-get-state-from-the-redux-store");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-redux-get-state-from-the-redux-store!./.cache/json/front-end-libraries-redux-get-state-from-the-redux-store.json
// module id = 2109
// module chunks = 231608221292675